/** Коды справочника «Тип документов фиксирующих нарушение» */
export const isPhotoTypeDocConfirmationViolation = (code?: string | null): boolean => !!code && /^photo$/i.test(code);

export const isVideoTypeDocConfirmationViolation = (code?: string | null): boolean => !!code && /^video$/i.test(code);
